import { render, staticRenderFns } from "./TypeImages.vue?vue&type=template&id=3f6d997f&scoped=true&"
import script from "./TypeImages.vue?vue&type=script&lang=js&"
export * from "./TypeImages.vue?vue&type=script&lang=js&"
import style0 from "./TypeImages.vue?vue&type=style&index=0&id=3f6d997f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6d997f",
  null
  
)

export default component.exports